import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import selectors from '../selectors';
import entryActions from '../entry-actions';
import Core from '../components/Core';

const mapStateToProps = state => {
  const isInitializing = selectors.selectIsInitializing(state);
  const isSocketDisconnected = selectors.selectIsSocketDisconnected(state);
  const currentModal = selectors.selectCurrentModal(state);
  const currentProject = selectors.selectCurrentProject(state);
  const currentBoard = selectors.selectCurrentBoard(state);

  return {
    isInitializing,
    isSocketDisconnected,
    currentModal,
    currentProject,
    currentBoard,
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onOpenUserSettings: entryActions.openUserSettingsModal,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Core);
